import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import ReportReasonForm from './ReportReasonForm'
import ReportCategoryForm from './ReportCategoryForm'
import reportService from '../../../services/reportService'

const ReportPostModal = ({ post, comment, open, setOpenReportPostModal, submitOnSuccess }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [openSecondModal, setOpenSecondModal] = useState(false)

  const submitHandler = ({ category, reason }) => {
    const form = { category, reason }
    form.postId = post?.id
    form.commentId = comment?.id
    return reportService.createReport({ ...form })
      .then(res => {
        onCloseHandler()
        enqueueSnackbar('Successfully reported a content!', { variant: 'success' })
      })
      .catch(err => enqueueSnackbar(err.response.data.message, { variant: 'error' }))
  }

  const onCloseHandler = () => {
    setOpenReportPostModal(false)
    setOpenSecondModal(false)
  }

  const onNextModalHandler = () => {
    setOpenReportPostModal(false)
    setOpenSecondModal(true)
  }

  const onBackModalHandler = () => {
    setOpenSecondModal(false)
    setOpenReportPostModal(true)
    methods.setValue('reason', null)
  }

  const secondModalOnCloseHandler = () => {
    setOpenSecondModal(false)
  }

  const methods = useForm({ mode: 'onChange' })

  return (
    <>
      {open
        ? (
        <Dialog
          open={open}
          onClose={onCloseHandler}
          // scroll="paper"
        >
          <ReportCategoryForm post={post} comment={comment} methods={methods} onNext={onNextModalHandler} onClose={onCloseHandler}/>
        </Dialog>
          )
        : undefined
      }
      {openSecondModal
        ? (
          <Dialog
            open={openSecondModal}
            onClose={onCloseHandler}
            // scroll="paper"
          >
            <ReportReasonForm post={post} comment={comment} methods={methods} onBack={onBackModalHandler} onSubmit={submitHandler} onClose={secondModalOnCloseHandler} submitButtonLabel="Submit"/>
          </Dialog>
          )
        : undefined
      }
    </>
  )
}

export default ReportPostModal
